/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Complete_Purchase_ButtonInputs */

const en_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete purchase`)
};

const id_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesaikan pembelian`)
};

const ms_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengkapkan pembelian`)
};

const ca_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar la compra`)
};

const cs_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončit nákup`)
};

const da_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemfør køb`)
};

const de_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauf abschließen`)
};

const et_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lõpeta ost`)
};

const es_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar compra`)
};

const fr_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finaliser l’achat`)
};

const hr_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dovršite plaćanje`)
};

const it_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa acquisto`)
};

const lv_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabeigt pirkumu`)
};

const lt_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Užbaigti pirkimą`)
};

const hu_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vásárlás befejezése`)
};

const nl_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankoop voltooien`)
};

const nb_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullfør kjøpet`)
};

const pl_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukończ zakup`)
};

const pt_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizar compra`)
};

const ro_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizează achiziția`)
};

const sk_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončiť nákup`)
};

const sl_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaključi nakup`)
};

const fi_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suorita osto`)
};

const sv_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slutför köpet`)
};

const vi_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tất mua hàng`)
};

const tr_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın alma işlemini tamamla`)
};

const el_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ολοκλήρωση αγοράς`)
};

const bg_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завършване на покупката`)
};

const ru_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершить покупку`)
};

const sr_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Довршите плаћање`)
};

const uk_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершити покупку`)
};

const ka_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გადახდის დასრულება`)
};

const hi_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परचेस पूरा करें`)
};

const th_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำรายการซื้อให้เสร็จสมบูรณ์`)
};

const ko_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 완료`)
};

const zh_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成购买`)
};

const zh_tw_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成購買`)
};

const ja_complete_purchase_button = /** @type {(inputs: Complete_Purchase_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入を完了`)
};

/**
* | output |
* | --- |
* | "Complete purchase" |
*
* @param {Complete_Purchase_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const complete_purchase_button = /** @type {((inputs?: Complete_Purchase_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Complete_Purchase_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_complete_purchase_button(inputs)
	if (locale === "ms") return ms_complete_purchase_button(inputs)
	if (locale === "ca") return ca_complete_purchase_button(inputs)
	if (locale === "cs") return cs_complete_purchase_button(inputs)
	if (locale === "da") return da_complete_purchase_button(inputs)
	if (locale === "de") return de_complete_purchase_button(inputs)
	if (locale === "et") return et_complete_purchase_button(inputs)
	if (locale === "es") return es_complete_purchase_button(inputs)
	if (locale === "fr") return fr_complete_purchase_button(inputs)
	if (locale === "hr") return hr_complete_purchase_button(inputs)
	if (locale === "it") return it_complete_purchase_button(inputs)
	if (locale === "lv") return lv_complete_purchase_button(inputs)
	if (locale === "lt") return lt_complete_purchase_button(inputs)
	if (locale === "hu") return hu_complete_purchase_button(inputs)
	if (locale === "nl") return nl_complete_purchase_button(inputs)
	if (locale === "nb") return nb_complete_purchase_button(inputs)
	if (locale === "pl") return pl_complete_purchase_button(inputs)
	if (locale === "pt") return pt_complete_purchase_button(inputs)
	if (locale === "ro") return ro_complete_purchase_button(inputs)
	if (locale === "sk") return sk_complete_purchase_button(inputs)
	if (locale === "sl") return sl_complete_purchase_button(inputs)
	if (locale === "fi") return fi_complete_purchase_button(inputs)
	if (locale === "sv") return sv_complete_purchase_button(inputs)
	if (locale === "vi") return vi_complete_purchase_button(inputs)
	if (locale === "tr") return tr_complete_purchase_button(inputs)
	if (locale === "el") return el_complete_purchase_button(inputs)
	if (locale === "bg") return bg_complete_purchase_button(inputs)
	if (locale === "ru") return ru_complete_purchase_button(inputs)
	if (locale === "sr") return sr_complete_purchase_button(inputs)
	if (locale === "uk") return uk_complete_purchase_button(inputs)
	if (locale === "ka") return ka_complete_purchase_button(inputs)
	if (locale === "hi") return hi_complete_purchase_button(inputs)
	if (locale === "th") return th_complete_purchase_button(inputs)
	if (locale === "ko") return ko_complete_purchase_button(inputs)
	if (locale === "zh") return zh_complete_purchase_button(inputs)
	if (locale === "zh-tw") return zh_tw_complete_purchase_button(inputs)
	if (locale === "ja") return ja_complete_purchase_button(inputs)
	return en_complete_purchase_button(inputs)
});